"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Social_otherSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 30, height: 30, viewBox: "0 0 30 30" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { transform: "translate(-310 -743) translate(310 743)" },
            react_1.default.createElement("circle", { cx: 15, cy: 15, r: 12, fill: "#FFF" }),
            react_1.default.createElement("path", { fill: "#597EFF", d: "M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm0 8c-.482 0-.954.049-1.409.143C10.405 8.796 8 11.623 8 15c0 3.86 3.14 7 7 7s7-3.14 7-7c0-3.377-2.404-6.204-5.591-6.857C15.954 8.049 15.483 8 15 8zm-.387 2c.06.071.1.137.1.183 0 .206.414.459.795.687l.245.147c.115.07.216.137.286.195.326.275-.605.664-1.232 1.03-.628.366-.605 1.579-.768 1.373-.162-.206-1.232-1.556-1.441-.137-.21 1.418.465.709.72.663.256-.045.233.206.14.435-.093.23 1.07.55 1.442.595.372.046.767-.457 1.302 0 .535.458 1.86.87 2.511 1.03.65.16.023.984-.209 1.602-.233.618-2.093 2.174-3.371 2.197-.296.006.883-1.693.162-2.036-.72-.344-.72-1.236-.65-1.877.07-.64-.977-.572-2.767-1.625-1.105-.65-.956-2.065-.679-3.055.896-.839 2.093-1.364 3.414-1.407z" })));
}
function Social_other(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Social_otherSvg, Object.assign({}, svgProps)));
}
exports.default = Social_other;
//# sourceMappingURL=Social_other.js.map